import { render, staticRenderFns } from "./AwardPicture.vue?vue&type=template&id=21f7f12d&scoped=true&"
import script from "./AwardPicture.vue?vue&type=script&lang=js&"
export * from "./AwardPicture.vue?vue&type=script&lang=js&"
import style0 from "./AwardPicture.vue?vue&type=style&index=0&id=21f7f12d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f7f12d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f7f12d')) {
      api.createRecord('21f7f12d', component.options)
    } else {
      api.reload('21f7f12d', component.options)
    }
    module.hot.accept("./AwardPicture.vue?vue&type=template&id=21f7f12d&scoped=true&", function () {
      api.rerender('21f7f12d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/theme/components/AwardPicture.vue"
export default component.exports